import { h, Component } from "preact";
import * as _ from "../components/index.js";
import rulesData from "../data/rules.json";

const NUM_PREFIX = /^(\d+(?:\.\d+)*)\.\s+/;

function renderParagraph(p, i, keyPrefix = "") {
  const m = p.match(NUM_PREFIX);
  if (m) {
    const rest = p.slice(m[0].length);
    return (
      <div class="rule_para" key={`${keyPrefix}${i}`}>
        <span class="rule_num">{m[1]}.</span>
        <span class="rule_text">{rest}</span>
      </div>
    );
  }
  return (
    <div class="rule_para rule_para_plain" key={`${keyPrefix}${i}`}>
      {p}
    </div>
  );
}

function renderAppendix(app) {
  return (
    <div class="rule_appendix" key={`app${app.id}`}>
      <h4 class="rule_appendix_title">
        ПРИЛОЖЕНИЕ № {app.id} к Правилам дорожного движения | {app.title}
      </h4>
      {app.paragraphs.map((p, i) => renderParagraph(p, i, `app${app.id}_`))}
      {app.images && app.images.length > 0 && (
        <div class="rule_images mt-3">
          {app.images.map((src, i) => (
            <img key={i} src={src} alt="" class="rule_image" />
          ))}
        </div>
      )}
    </div>
  );
}

export default class Rule extends Component {
  render() {
    const { id } = this.props;
    const section = rulesData.sections.find((s) => String(s.id) === String(id));

    if (!section) {
      return (
        <>
          <_.Header title="Правила" backurl="/rules" />
          <section class="menu">
            <p>Раздел не найден.</p>
          </section>
        </>
      );
    }

    return (
      <>
        <_.Header title={section.title} backurl="/rules" />
        <section class="menu rule_view">
          {section.paragraphs.map((p, i) => renderParagraph(p, i))}
          {section.images && section.images.length > 0 && (
            <div class="rule_images mt-3">
              {section.images.map((src, i) => (
                <img key={i} src={src} alt="" class="rule_image" />
              ))}
            </div>
          )}
          {rulesData.appendices.map((app) => renderAppendix(app))}
        </section>
      </>
    );
  }
}
